<div [ngClass]="'panel ' + color">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span>Equipment</span>
        </h5>
        <div class="btn-toolbar pull-right">
            <ng-container *ngIf="!live">
                <div class="btn-group btn-group-md" *ngIf="!listOnly">
                    <button type="button" class="btn btn-primary" title="Add Model" (click)="addModel()">
                        <i data-toggle="tooltip" class="fa fa-plus-square fa-lg"></i>
                    </button>
                </div>
            </ng-container>
            <div class="btn-group btn-group-md">
                <equipment-filter [live]="live"></equipment-filter>
            </div>
            <ng-container *ngIf="!live">
                <div class="btn-group btn-group-md" *ngIf="!listOnly">
                    <div>
                        <button type="button" class="btn btn-info" title="Manage Attributes" (click)="addAttribute()">
                            <i data-toggle="tooltip" class="fa fa-tags fa-lg"></i>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="panel-body panel-list">
        <div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
            <i class="fa fa-spinner fa-spin"></i> Loading Models...
        </div>
        <div class="panel-group" style="height:370px" *ngIf="!processing">
            <model-entity [live]="live" [listOnly]="listOnly" [model]="model" [full]="true" *ngFor="let model of models.Data"></model-entity>
        </div>
    </div>
</div>
